
export const print_detail_list = () => ([
  {
    _id: "status",
    label: "Order Status",
    enabled: true,
  },
  {
    _id: "config.service",
    label: "Order Service",
    enabled: true,
  },
  {
    _id: "created",
    label: "Order Placed",
    enabled: true,
  },
  {
    _id: "config.due",
    label: "Order Due Date",
    enabled: true,
  },
  {
    _id: "ready_in",
    label: "Order Est. Ready Time",
    enabled: true,
  },
  {
    _id: "pickup_in",
    label: "Order Est. Driver Pickup Time",
    enabled: true,
  },
  {
    _id: "delivery_in",
    label: "Order Est. Delivery Time",
    enabled: true,
  },
  {
    _id: "payment.method",
    label: "Payment Method",
    enabled: true,
  },
  {
    _id: "payment.currency",
    label: "Payment Currency (Multi-currency stores only)",
    enabled: true,
  },
  {
    _id: "payment.status",
    label: "Payment Status (Online Payments)",
    enabled: true,
  },
  {
    _id: "notes",
    label: "Customer Notes",
    enabled: true,
  },
  {
    _id: "config.table",
    label: "Table Name (Dine-In)",
    enabled: true,
  },
  {
    _id: "config.number_of_people",
    label: "Number Of People (Dine-In)",
    enabled: true,
  },
  {
    _id: "config.destination",
    label: "Delivery Address",
    enabled: true,
  },
  {
    _id: "config.zone",
    label: "Delivery Zone",
    enabled: true,
  },
  {
    _id: "config.distance",
    label: "Delivery Distance (km)",
    enabled: true,
  },
  {
    _id: "config.driving_time",
    label: "Delivery Driving Time (minutes)",
    enabled: true,
  },
  {
    _id: "config.tookan",
    label: "Tookan Delivery Booking Status",
    enabled: true,
  },
  {
    _id: "customer.name",
    label: "Customer Name",
    enabled: true,
  },
  {
    _id: "customer.email",
    label: "Customer Email",
    enabled: true,
  },
  {
    _id: "customer.phone",
    label: "Customer Phone",
    enabled: true,
  },
]);

export const print_detail_list_customer = () => print_detail_list().map((item) => {
  const enabled = ["pickup_in", "config.zone", "config.distance", "config.driving_time", "config.tookan"].indexOf(item._id) === -1;
  return {
    ...item,
    enabled: enabled,
  };
});
